// extracted by mini-css-extract-plugin
export default {"iframeScrollWrapper":"styles__iframeScrollWrapper--FxXhO","iframeContent":"styles__iframeContent--Ew67H","splashScreen":"styles__splashScreen--oHRcV","loadingWrapper":"styles__loadingWrapper--Z9PXH"};
    if(module.hot) {
      // 1734354131075
      var cssReload = require("!../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  